import { render, staticRenderFns } from "./HistoryTask.vue?vue&type=template&id=6a86a0ce&"
import script from "./HistoryTask.vue?vue&type=script&lang=js&"
export * from "./HistoryTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports